import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useParams, useNavigate } from 'react-router-dom';
// 
import {
    Row,
    Col,
    Button
} from 'reactstrap';
import { useTable, useSortBy } from "react-table";
import Numeral from 'numeral';
import { Spinner } from 'reactstrap';
import { CSVDownload } from 'react-csv';
import moment from 'moment-timezone';
// services
import AuthService from '../../services/AuthService.js';
import DealerService from '../../services/DealerService.js';
import ContractService from '../../services/ContractService.js';
import UserService from '../../services/UserService.js';

// components
import LoadingPage from '../LoadingPage';
import Notifications from '../Notifications.js';


function DealerAccountingPage() {

    const { id } = useParams()
    const navigate = useNavigate();

    const userRole = UserService.getUserRole();
    const [netSuiteId, setNetSuiteId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [metricsCalculated, setMetricsCalculated] = useState(false)
    const [contractsCreated, setContractsCreated] = useState(null)
    const [contractsFinalized, setContractsFinalized] = useState(null)
    const [contractsCancelled, setContractsCancelled] = useState(null)
    const [totalSnapshotPrice, setTotalSnapshotPrice] = useState(null)
    const [totalSalesPrice, setTotalSalesPrice] = useState(null)
    const [productBreakdown, setProductBreakdown] = useState({})
    const [salesSummaryLoading, setSalesSummaryLoading] = useState(false)
    const [salesSummaryMonthLabel, setSalesSummaryMonthLabel] = useState('')
    const [salesSummaryYearLabel, setSalesSummaryYearLabel] = useState('')
    const [invoiceDownloadLoading, setInvoiceDownloadLoading] = useState(false)
    const [creditMemoDownloadLoading, setCreditMemoDownloadLoading] = useState(false)
    const [csvDownloadReady, setCSVDownloadReady] = useState(false)
    const [csvDownloadLoading, setCSVDownloadLoading] = useState(false)
    const [csvData, setCSVData] = useState([])
    const [reportDownloadReady, setReportDownloadReady] = useState(false)
    const [reportDownloadLoading, setReportDownloadLoading] = useState(false)
    const [reportData, setReportData] = useState([])
    const [data, setData] = useState([])
    const [month, setMonth] = useState(null);
    const [monthLabels, setMonthLabels] = useState([
        {
            value: '1',
            label: 'January'
        },
        {
            value: '2',
            label: 'February'
        },
        {
            value: '3',
            label: 'March'
        },
        {
            value: '4',
            label: 'April'
        },
        {
            value: '5',
            label: 'May'
        },
        {
            value: '6',
            label: 'June'
        },
        {
            value: '7',
            label: 'July'
        },
        {
            value: '8',
            label: 'August'
        },
        {
            value: '9',
            label: 'September'
        },
        {
            value: '10',
            label: 'October'
        },
        {
            value: '11',
            label: 'November'
        },
        {
            value: '12',
            label: 'December'
        }
    ]);

    const [year, setYear] = useState(null)
    const getYears = () => {
        const years = []
        const currentYear = new Date().getFullYear()
        for(let year = currentYear; year >= 2013; year--) {
            years.push({
                value: year.toString(),
                label: year.toString()
            })
        }
        return years
    };
    const [yearLabels, setYearLabels] = useState(getYears());

    useEffect(() => {
        setLoading(true)
        DealerService.getDealer(id).then(response => {
            setNetSuiteId(response.data.netSuiteId)
        }, e => {
            if (e.statusCode === 401 && e.message === 'Token is expired, please update your token.') {
                AuthService.logout()
                navigate('/login')
            }
            Notifications("error", e.message)
        })
        setLoading(false)
    }, [id, navigate])

    useEffect(() => {
        if (csvData.length) {
            setCSVDownloadReady(true)
        }
    }, [csvData])
    useEffect(() => {
        if (csvDownloadReady) {
            setCSVDownloadReady(false)
        }
    }, [csvDownloadReady])
    useEffect(() => {
        if (reportData.length) {
            setReportDownloadReady(true)
        }
    }, [reportData])
    useEffect(() => {
        if (reportDownloadReady) {
            setReportDownloadReady(false)
        }
    }, [reportDownloadReady])

    const handleMonthChange = (monthLabel) => {
        setMonth(monthLabel)
    }

    const handleYearChange = (yearLabel) => {
        setYear(yearLabel)
    }

    const sameMonthAndYear = (date1, date2) => {
        const firstDate = new Date(date1)
        const secondDate = new Date(date2)
        return firstDate.getUTCFullYear() === secondDate.getUTCFullYear() && firstDate.getUTCMonth() === secondDate.getUTCMonth()
    };

    const calculateAllMetrics = (contracts) => {

        let numberCreatedMatches = 0
        let numberFinalizedMatches = 0
        let numberCancelledMatches = 0
        let totalPrice = 0
        let totalInternalPrice = 0
        let productMapping = {}
        const selectedDate = new Date(Date.UTC(parseInt(year.value), parseInt(month.value) - 1))
        contracts.forEach(contract => {
            const pricingSnapshot = JSON.parse(contract.pricingSnapshot)
            if (sameMonthAndYear(contract.createdAt, selectedDate.toISOString())) {
                numberCreatedMatches += 1
            }
            if (contract.finalizedAt !== null && (contract.cancelledAt == null || !sameMonthAndYear(contract.cancelledAt, selectedDate.toISOString())) && sameMonthAndYear(contract.finalizedAt, selectedDate.toISOString())) {
                numberFinalizedMatches += 1
                totalPrice += pricingSnapshot.price.slice(-1)[0]
                totalInternalPrice += pricingSnapshot.price[0]
            }
            if (contract.cancelledAt !== null && sameMonthAndYear(contract.cancelledAt, selectedDate.toISOString())) {
                numberCancelledMatches += 1
            }
            

            if (!productMapping[pricingSnapshot.title]) {
                productMapping[pricingSnapshot.title] = {
                    title: pricingSnapshot.title,
                    totalContractsCreated: 0,
                    totalContractsFinalized: 0,
                    totalContractsCancelled: 0,
                    price: 0,
                    internalPrice: 0
                }
            } 

            if (sameMonthAndYear(contract.createdAt, selectedDate.toISOString())) {
                productMapping[pricingSnapshot.title]['totalContractsCreated'] += 1
            }
            if (contract.finalizedAt !== null && (contract.cancelledAt == null || !sameMonthAndYear(contract.cancelledAt, selectedDate.toISOString())) && sameMonthAndYear(contract.finalizedAt, selectedDate.toISOString())) {
                productMapping[pricingSnapshot.title]['totalContractsFinalized'] += 1 
                productMapping[pricingSnapshot.title].price += pricingSnapshot.price.slice(-1)[0]
                productMapping[pricingSnapshot.title].internalPrice += pricingSnapshot.price[0]
            }
            if (sameMonthAndYear(contract.cancelledAt, selectedDate.toISOString())) {
                productMapping[pricingSnapshot.title]['totalContractsCancelled'] += 1 
            }

        });
        setContractsCreated(numberCreatedMatches)
        setContractsFinalized(numberFinalizedMatches)
        setContractsCancelled(numberCancelledMatches)
        setTotalSnapshotPrice(totalPrice)
        setTotalSalesPrice(totalInternalPrice)
        setProductBreakdown(productMapping)
        setData(Object.entries(productMapping).map(([title, details]) => ({
            title,
            ...details
        })))
        setMetricsCalculated(true)


    };

    const handleInvoiceSubmit = () => {
        setInvoiceDownloadLoading(true)

        Notifications("info", 'Download started')

        if (netSuiteId !== '') {
            DealerService.getDealerInvoice(netSuiteId.toString(), month.value, year.value).then(response => {
                setInvoiceDownloadLoading(false)
            }, e => {
                if (e.statusCode === 401 && e.message === 'Token is expired, please update your token.') {
                    AuthService.logout()
                    navigate('/login')
                }
                Notifications("error", e.message)
    
                setInvoiceDownloadLoading(false)
            })
        } else {
            Notifications('error', 'This dealer does not have a NetSuite ID.')
        }
        
    };

    const handleCreditMemoSubmit = () => {
        setCreditMemoDownloadLoading(true)

        Notifications("info", 'Download started')

        if (netSuiteId !== '') {
            DealerService.getDealerCreditMemo(netSuiteId.toString(), month.value, year.value).then(response => {
                setCreditMemoDownloadLoading(false)
            }, e => {
                if (e.statusCode === 401 && e.message === 'Token is expired, please update your token.') {
                    AuthService.logout()
                    navigate('/login')
                }
                Notifications("error", e.message)
    
                setCreditMemoDownloadLoading(false)
            })
        } else {
            Notifications('error', 'This dealer does not have a NetSuite ID.')
        }
        
    };

    const handleCSVDownload = async () => {

        setCSVDownloadLoading(true)

        Notifications("info", 'Download started')

        try {
            
            let nextMonth = parseInt(month.value) + 1
            let nextYear = parseInt(year.value)
            if (nextMonth > 12) {
                nextMonth = 1
                nextYear += 1
            }

            const startDate = moment({
                year: year.value,
                month: parseInt(month.value) - 1
            })
            const endDate = moment({
                year: nextYear,
                month: nextMonth - 1
            })

            let response = await ContractService.getAllContracts(
                null,
                null,
                startDate.toISOString(),
                endDate.toISOString(),
                startDate.toISOString(),
                endDate.toISOString(),
                null,
                null,
                null,
                null,
                id,
                null,
                null,
                null
            )

            if (response.data.length === 0) {
                Notifications('error', 'No contracts to download.')
                setCSVDownloadLoading(false)
                return;
            }
            let contractSummary = []
            response.data.forEach(contract => {
                if (sameMonthAndYear(contract.finalizedAt, startDate.toISOString()) || sameMonthAndYear(contract.cancelledAt, startDate.toISOString())) {
                    let managerName = ''
                    let managerEmail = ''

                    if (contract.vendorInfo !== null) {
                        if (contract.vendorInfo.trim().includes(',')) {
                            let manager = contract.vendorInfo.trim().split(',')
                            managerName = manager[0].trim()
                            managerEmail = manager[1].trim()
                        } else {
                            managerName = contract.vendorInfo.trim()
                        }
                    }
                    
                    const ownerInfo = JSON.parse(contract.owner)
                    const pricingSnapshot = JSON.parse(contract.pricingSnapshot)

                    let columns = {
                        id: contract.id,
                        dealer: contract.dealer.name,
                        product: pricingSnapshot === null ? '' : pricingSnapshot.title,
                        term: pricingSnapshot === null ? '' : pricingSnapshot.term,
                        activationDate: moment(contract.activationDate).format('YYYY-MM-DD'),
                        vin: contract.vin,
                        userEmail: contract.userEmail,
                        totalPrice: pricingSnapshot === null ? null : pricingSnapshot.price.slice(-1),
                        sellingPrice: contract.sellingPrice,
                        status: contract.status.replace('_', ' '),
                        theftId: contract.theftId,
                        mileage: contract.mileage,
                        vehicleYear: contract.vehicleYear,
                        make: contract.make,
                        model: contract.model,
                        color: contract.color,
                        stock: contract.stock,
                        purchasePrice: contract.purchasePrice,
                        removed: contract.removed ? 'true' : 'false',
                        dealerId: contract.dealerId,
                        userId: contract.userId,
                        createdAt: contract.createdAt !== null ? moment(contract.createdAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        updatedAt: contract.updatedAt !== null ? moment(contract.updatedAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        finalizedAt: contract.finalizedAt !== null ? moment(contract.finalizedAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        cancelledAt: contract.cancelledAt !== null ? moment(contract.cancelledAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        netSuiteDealerId: contract.netSuiteDealerId,
                        legacyContractId: contract.legacyContractId,
                        managerName: managerName,
                        managerEmail: managerEmail,
                        ownerType: ownerInfo.ownerType,
                        firstName: ownerInfo.firstName,
                        lastName: ownerInfo.lastName,
                        email: ownerInfo.email,
                        phone: ownerInfo.phone,
                        address: ownerInfo.address,
                        zip: ownerInfo.zip,
                        city: ownerInfo.city,
                        state: ownerInfo.state,
                        lienholderName: ownerInfo.lienholderName,
                        lienholderAddress: ownerInfo.lienholderAddress
                    }

                    if (userRole === 'SUPERADMIN' && pricingSnapshot !== null) {
                        pricingSnapshot.additionalItems.forEach(item => {
                            columns[item.additionalItemCode.code] = item.fee
                        })
                    }
                    
                    contractSummary.push(columns)
                }
            });
            setCSVData(contractSummary)
            setCSVDownloadLoading(false)
            
        } catch (e) {

            if (e.statusCode === 401 && e.message === 'Token is expired, please update your token.') {
                AuthService.logout()
                navigate('/login')
            }
            Notifications("error", e['message'])

            setCSVDownloadLoading(false)

        }
    };

    const handleReportDownload = async () => {
        
        setReportDownloadLoading(true)

        Notifications("info", 'Download started')

        try {

            let nextMonth = parseInt(month.value) + 1
            let nextYear = parseInt(year.value)
            if (nextMonth > 12) {
                nextMonth = 1
                nextYear += 1
            }

            const startDate = moment({
                year: year.value,
                month: parseInt(month.value) - 1
            })
            const endDate = moment({
                year: nextYear,
                month: nextMonth - 1
            })

            let response = await ContractService.getAllContracts(
                null,
                null,
                startDate.toISOString(),
                endDate.toISOString(),
                startDate.toISOString(),
                endDate.toISOString(),
                null,
                null,
                null,
                null,
                id,
                null,
                null,
                null
            )
            if (response.data.length === 0) {
                Notifications('error', 'No contracts to download.')
                setReportDownloadLoading(false)
                return;
            }

            let reportSummary = []
            response.data.forEach(contract => {
                const pricingSnapshot = JSON.parse(contract.pricingSnapshot)
                const ownerInfo = JSON.parse(contract.owner)
                if (sameMonthAndYear(contract.finalizedAt, startDate.toISOString()) && pricingSnapshot.additionalItems.length > 0) {
                    let finalizedColumns = {
                        'Customer NS #': netSuiteId,
                        'Customer Name': contract.dealer.name,
                        'Contract #': contract.id,
                        'Product': pricingSnapshot.title,
                        'Term': pricingSnapshot.term,
                        'Finalized Date': contract.finalizedAt !== null ? moment(contract.finalizedAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        'Cancelled Date': contract.cancelledAt !== null ? moment(contract.cancelledAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        'VIN #': contract.vin,
                        'Vehicle Year': contract.vehicleYear,
                        'Make': contract.make,
                        'Model': contract.model,
                        'First Name': ownerInfo.firstName.toUpperCase(),
                        'Last Name': ownerInfo.lastName.toUpperCase(),
                    }
                    pricingSnapshot.additionalItems.forEach(item => {
                        let tempFinalizedColumns = { ...finalizedColumns }
                        tempFinalizedColumns['Code'] = item.additionalItemCode.code
                        tempFinalizedColumns['Fee'] = item.fee

                        reportSummary.push(tempFinalizedColumns)
                    })
                }

                if (sameMonthAndYear(contract.cancelledAt, startDate.toISOString()) && pricingSnapshot.additionalItems.length > 0 && contract.finalizedAt !== null) {
                    let cancelledColumns = {
                        'Customer NS #': netSuiteId,
                        'Customer Name': contract.dealer.name,
                        'Contract #': contract.id,
                        'Product': pricingSnapshot.title,
                        'Term': pricingSnapshot.term,
                        'Finalized Date': contract.finalizedAt !== null ? moment(contract.finalizedAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        'Cancelled Date': contract.cancelledAt !== null ? moment(contract.cancelledAt).format('YYYY-MM-DD, h:mm:ss a') : null,
                        'VIN #': contract.vin,
                        'Vehicle Year': contract.vehicleYear,
                        'Make': contract.make,
                        'Model': contract.model,
                        'First Name': ownerInfo.firstName.toUpperCase(),
                        'Last Name': ownerInfo.lastName.toUpperCase(),
                    }
                    pricingSnapshot.additionalItems.forEach(item => {
                        let tempCancelledColumns = { ...cancelledColumns }

                        tempCancelledColumns['Code'] = item.additionalItemCode.code
                        tempCancelledColumns['Fee'] = -1 * item.fee

                        reportSummary.push(tempCancelledColumns)
                    })
                }
            })
            setReportData(reportSummary)
            setReportDownloadLoading(false)
        } catch (e) {
            if (e.statusCode === 401 && e.message === 'Token is expired, please update your token.') {
                AuthService.logout()
                navigate('/login')
            }
            Notifications("error", e['message'])
            setReportDownloadLoading(false)
        }
    };

    const handleSalesSummarySubmit = () => {
        setSalesSummaryLoading(true)

        let nextMonth = parseInt(month.value) + 1
        let nextYear = parseInt(year.value)
        if (nextMonth > 12) {
            nextMonth = 1
            nextYear += 1
        }

        const startDate = moment({
            year: year.value,
            month: parseInt(month.value) - 1
        })
        const endDate = moment({
            year: nextYear,
            month: nextMonth - 1
        })

        ContractService.getAllContracts(null, null, startDate.toISOString(), endDate.toISOString(), startDate.toISOString(), endDate.toISOString(), null, null, null, null, id, null, null, null).then(response => {
            calculateAllMetrics(response.data)
        }, e => {
            if (e.statusCode === 401 && e.message === 'Token is expired, please update your token.') {
                AuthService.logout()
                navigate('/login')
            }
            Notifications("error", e.message)
        })

        setSalesSummaryMonthLabel(month.label)
        setSalesSummaryYearLabel(year.label)
        setSalesSummaryLoading(false)
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'Product',
                accessor: 'title',
                Cell: ({ cell }) => {
                    const { value } = cell;
                    return (
                        <div className="table-cell__div">
                            {value}
                        </div>
                    );
                }
            },
            {
                Header: 'Total Contracts Created',
                accessor: 'totalContractsCreated',
                Cell: ({ cell }) => {
                    const { value } = cell;
                    return (
                        <div className="table-cell__div">
                            {value}
                        </div>
                    );
                }
            },
            {
                Header: 'Total Contracts Finalized',
                accessor: 'totalContractsFinalized',
                Cell: ({ cell }) => {
                    const { value } = cell;
                    return (
                        <div className="table-cell__div">
                            {value}
                        </div>
                    );
                }
            },
            {
                Header: 'Total Contracts Cancelled',
                accessor: 'totalContractsCancelled',
                Cell: ({ cell }) => {
                    const { value } = cell;
                    return (
                        <div className="table-cell__div">
                            {value}
                        </div>
                    );
                }
            },
            {
                Header: 'Total Price',
                accessor: 'price',
                Cell: ({ cell }) => {
                    const { value } = cell;
                    return (
                        <div className="table-cell__div">
                            {Numeral(value).format("$0,0.00")}
                        </div>
                    );
                }
            },
            {
                Header: 'Total Sales',
                accessor: 'internalPrice',
                Cell: ({ cell }) => {
                    const { value } = cell;
                    return (
                        <div className="table-cell__div">
                            {Numeral(value).format("$0,0.00")}
                        </div>
                    );
                }
            }
        ], [] 
    )

    function Table({ columns, data }) {
        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            rows,
            prepareRow,
        } = useTable(
            {
                columns,
                data,
                initialState: {
                    sortBy: [
                        {
                            id: 'title'
                        }
                    ],
                    ...(userRole !== 'SUPERADMIN' && userRole !== 'METROTECH_ADMIN' && userRole !== 'METROTECH_MANAGER' && userRole !== 'METROTECH_TERRITORY_MANAGER') && {hiddenColumns: ['internalPrice']},
                }
            },
            useSortBy
        );
        return (
            <React.Fragment>
                <div className='table-div'>
                    <table {...getTableProps()}>
                        <thead>
                            {
                                headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {
                                            headerGroup.headers.map((column) => (
                                                <th className='table-header'{...column.getHeaderProps()}>
                                                    <div className='table-header__div'>
                                                        {column.render("Header")}
                                                    </div>          
                                                </th>
                                            ))
                                        }
                                    </tr>
                                ))
                            }
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {
                                rows.map((row, i) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()} className="table-row">
                                        {row.cells.map((cell) => {
                                            return <td {...cell.getCellProps()} className="flex-end">{cell.render("Cell")}</td>;
                                        })}
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>  
            </React.Fragment>
        )
    }

    if (loading) {
        return (
            <React.Fragment>
                <LoadingPage />
            </React.Fragment>
        );
    }

    return (
        <>
            <div className="content-row flex-grow">
                <div className="details-page__form" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Row>
                        <Col xs={12} md={6}>
                            <div className='details-page__form-elements'>
                                <label>
                                    <div>Month*</div>
                                    <Select 
                                        options={monthLabels}
                                        value={month}
                                        onChange={handleMonthChange}
                                    />
                                </label>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className='details-page__form-elements'>
                                <label>
                                    <div>Year*</div>
                                    <Select 
                                        options={yearLabels}
                                        value={year}
                                        onChange={handleYearChange}
                                    />
                                </label>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
                                {/*<Button
                                    className="form-button"
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={() => handleInvoiceSubmit()}
                                    disabled={month === null || year === null}
                                >
                                    {
                                        invoiceDownloadLoading ?
                                            <div className='link-spinner'>
                                                <Spinner />
                                            </div>
                                            :
                                            <span>
                                                Download Invoice
                                            </span>
                                    }
                                </Button>*/}
                                <Button
                                    className="form-button"
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={() => handleCreditMemoSubmit()}
                                    disabled={month === null || year === null}
                                >
                                    {
                                        creditMemoDownloadLoading ?
                                            <div className='link-spinner'>
                                                <Spinner />
                                            </div>
                                            :
                                            <span>
                                                Download Credit Memo
                                            </span>
                                    }
                                </Button>
                                <Button
                                    className="form-button"
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={handleCSVDownload}
                                    disabled={month === null || year === null}
                                >
                                {
                                    csvDownloadLoading ? (
                                        <div className='link-spinner'>
                                            <Spinner />
                                        </div>
                                    ) : (
                                        <div className='link-spinner'>
                                            <span>
                                                Download CSV
                                            </span>
                                        </div>
                                    )
                                }
                                </Button>
                                {csvDownloadReady && (
                                    <CSVDownload
                                        data={csvData}
                                        filename={'contracts.csv'}
                                    />
                                )}
                                <Button
                                    className="form-button"
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={handleReportDownload}
                                    disabled={month === null || year === null}
                                >
                                {
                                    reportDownloadLoading ? (
                                        <div className='link-spinner'>
                                            <Spinner />
                                        </div>
                                    ) : (
                                        <div className='link-spinner'>
                                            <span>
                                                Download Rebate Report
                                            </span>
                                        </div>
                                    )
                                }
                                </Button>
                                {reportDownloadReady && (
                                    <CSVDownload
                                        data={reportData}
                                        filename={'report.csv'}
                                    />
                                )}
                                <Button
                                    className="form-button"
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={() => handleSalesSummarySubmit()}
                                    disabled={month === null || year === null}
                                >
                                    Sales Summary
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    {
                        salesSummaryLoading ?
                            <LoadingPage />
                            :
                            metricsCalculated && (
                                <>
                                    <Row>
                                        <Col xs={12}>
                                            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                                                <span>
                                                    <b>Sales Summary for {salesSummaryMonthLabel} {salesSummaryYearLabel}</b>
                                                </span>
                                                <span>
                                                    Total Contracts Created: {Numeral(contractsCreated).format("0,0")}{}
                                                </span>
                                                <span>
                                                    Total Contracts Finalized: {Numeral(contractsFinalized).format("0,0")}{}
                                                </span>
                                                <span>
                                                    Total Contracts Cancelled: {Numeral(contractsCancelled).format("0,0")}{}
                                                </span>
                                                <span>
                                                    Total Price: {Numeral(totalSnapshotPrice).format("$0,0.00")}
                                                </span>
                                                {
                                                    (userRole === 'SUPERADMIN' || userRole === 'METROTECH_ADMIN' || userRole === 'METROTECH_MANAGER' || userRole === 'METROTECH_TERRITORY_MANAGER')
                                                    &&
                                                    <span>
                                                        Total Sales: {Numeral(totalSalesPrice).format("$0,0.00")}
                                                    </span>
                                                }
                                                
                                            </div>
                                            <div className='table'>
                                                <Table columns={columns} data={data}/>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )
                    }
                </div>
            </div>
        </>
    )
}


export default DealerAccountingPage;